// extracted by mini-css-extract-plugin
export default {"root":"ProviderLeadsNav_root__ZTU0B","tab":"ProviderLeadsNav_tab__nFVgn"};